import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DownloadIcon from "@mui/icons-material/Download";
import UpdateIcon from "@mui/icons-material/Update";
import CustomTable from "components/CustomTable";
import CustomText from "components/typography/CustomText";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";

export default function CouponsTable({
  data = {},
  tab = "0",
  onDelete = () => {},
  onUpdate = () => {},
  onGenerate = () => {},
  onCancel = () => {},
}) {
  const auth = useSelector((state) => state?.auth ?? {});
  const history = useHistory();

  const handleClick = (row) => {
    history.push({
      pathname: `/customers/${row?.userid}`,
      state: { email: row?.owner ?? "" },
    });
  };

  return (
    <div>
      <CustomTable
        pageCount={25}
        height={600}
        data={data}
        couponTable={true}
        columns={[
          { label: "VOUCHER CODE", selector: "code" },
          {
            label: "CREATED",
            selector: "created_at",
            cell: (row) => moment(row.created_at).format("DD/MM/YYYY"),
          },
          {
            label: "EXPIRY DATE",
            selector: "expiry_date",
            cell: (row) => moment(+row.expiry_date * 1000).format("DD/MM/YYYY"),
          },
          { label: "PURCHASER", selector: "email" },
          {
            label: "OWNER",
            selector: "owner",
            cell: (row) => (
              <CustomText
                className="text-13 text-secondary"
                onClick={() => handleClick(row)}
              >
                {row?.owner}
              </CustomText>
            ),
          },
          {
            label: "Voucher Value",
            selector: "count",
            cellCSS: "py-4",
            sortValue: (row) => row.count?.id,
            cell: (row) => (
              <CustomText className="py-2">{row.count?.id}</CustomText>
            ),
          },
          {
            label: "REMAINING BOXES",
            selector: "count",
            cellCSS: "py-4",
            sortValue: (row) => row?.remain_boxes,
            cell: (row) => (
              <CustomText className="py-2">{row.remain_boxes}</CustomText>
            ),
          },
          {
            selector: "actions",
            cell: (row, index) => (
              <div className="flex">
                {tab === "0" && (
                  <>
                    {auth?.user?.email === "ben@sourcedevelopment.co.nz" && (<UpdateIcon
                      onClick={() => onUpdate(row)}
                      fontSize="large"
                    />)}
                    <DownloadIcon
                      fontSize="large"
                      onClick={() => onGenerate(row)}
                    />
                    <DeleteForeverIcon
                      onClick={() => onDelete(row, index)}
                      fontSize="large"
                    />
                  </>
                )}
                {tab === "1" && (
                  <CustomText
                    className="underline"
                    onClick={() => onCancel(row)}
                    bold
                  >
                    Unlink Voucher
                  </CustomText>
                )}
              </div>
            ),
          },
        ]}
      />
    </div>
  );
}
